@if (editInline()) {
    <se-alphanumeric-cell-editor-inline
        [alphanumericFormControl]="formControl"
        [notAdmissibleChars]="notAdmissibleChars()"
        [cellReady]="cellReady()"
    >
    </se-alphanumeric-cell-editor-inline>
} @else {
    <se-alphanumeric-cell-editor-popup
        [alphanumericFormControl]="formControl"
        [notAdmissibleChars]="notAdmissibleChars()"
        [width]="cellWidth()"
        [cellReady]="cellReady()"
    >
    </se-alphanumeric-cell-editor-popup>
}
